{
  "main": {
    "title": "Filtraggio dei dati"
  },
  "labels": {
    "datumOd": "Data DA:",
    "datumDo": "Data A:",
    "klubPJ": "Seleziona il club del pilota aliantista:",
    "klubPM": "Seleziona il club del pilota motore:",
    "klubJ": "Seleziona il club dell’aliante:",
    "klubM": "Seleziona il club dell’aereo a motore:",
    "pilot": "Seleziona il pilota:",
    "reg": "Seleziona la registrazione dell’aereo:",
    "casV": "Tempo di traino:",
    "stLetov": "Numero di voli:",
    "casVZ": "Tempo in aria:"
  },
  "data": {
    "title": "Dati"
  },
  "buttons": {
    "csv": "Esporta in CSV",
    "natisni": "Stampa",
    "poslji": "Invia",
    "brisiIzbiro": "Cancella selezione",
    "brisiZapis": "Elimina record"
  },
  "table": {
    "reg": "REG",
    "vzlet": "DECOLLO",
    "pilot": "PILOTA",
    "trajanje": "DURATA",
    "naloga": "COMPITO",
    "datum": "DATA",
    "pristanek": "ATTERRAGGIO",
    "titleJ": "Elenco dei voli a vela"
  },
  "modal": {
    "izbran": "Record selezionato",
    "reg": "registrazione:",
    "pilot": "pilota:",
    "regV": "reg. del traino:",
    "instruktor": "istruttore:",
    "namen": "scopo:",
    "naloga": "compito:",
    "casV": "ora del decollo:",
    "casO": "ora di sgancio:",
    "casP": "ora di atterraggio:",
    "casL": "tempo di volo:",
    "casVL": "tempo di traino:",
    "opomba": "nota:",
    "datumL": "data del volo:",
    "datumV": "data di inserimento:"
  }
}